<template>
  <div class="c-text--ellipsisTip" @mouseenter="mouseenter">
    <p ref="text"><slot></slot></p>
    <span v-if="isVisible"><slot></slot></span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      offsetW: 0,
      scrollW: 0
    };
  },
  computed: {
    isVisible() {
      return this.scrollW > this.offsetW;
    }
  },
  methods: {
    mouseenter() {
      if (this.$refs.text) {
        this.scrollW = this.$refs.text.scrollWidth;
        this.offsetW = this.$refs.text.offsetWidth;
      } else {
        this.scrollW = 0;
        this.offsetW = 0;
      }
    }
  }
};
</script>
